export default __webpack_public_path__ + "static/media/cta.b77cc426.jpg";